(function () {
    'use strict';

    angular
        .module('app')
        .run(run);

    var isUndefined = angular.isUndefined;

    run.$inject = ['$state', 'gettextCatalog', '$trace', '$transitions'];
    function run($state, gettextCatalog, $trace, $transitions) {
        // $state.go('test');
        // gettextCatalog.debug = true;
        /*
        var originalTraceHookResult = $trace.traceHookResult;
        $trace.traceHookResult = traceHookResult;
        $trace.enable();

        function traceHookResult(hookResult, trans, transitionOptions) {
            if (isUndefined(hookResult))
                hookResult = null;
            return originalTraceHookResult.call(this, hookResult, trans, transitionOptions);
        }
        */

        // Change in route, lets sent to analytics

        const glay = window['dataLayer'];
        $transitions.onSuccess({},
            function (event) {
                if (event && event.router && event.router.urlRouter && event.router.urlRouter.location) {
                    console.log(event.router.urlRouter.location);
                    glay.push({ 'event': 'pageView', 'pagePath': event.router.urlRouter.location });
                }
            });
    }
})();